import common from './common.json';

// import zhCN from 'hui-intl/lib/locale/lang/zh-CN';

const merge = Object.assign({}, common);
export default merge;